import React from "react";
import Particles, { ParticlesProvider } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const initializeParticles = async (engine) => {
  await loadSlim(engine);
};

const particleOptions = {
  fullScreen: {
    enable: false,
  },
  particles: {
    number: {
      value: 160,
      density: {
        enable: true,
        area: 1500,
      },
    },
    links: {
      enable: false,
      opacity: 0.03,
    },
    move: {
      enable: true,
      direction: "right",
      speed: 0.05,
    },
    size: {
      value: 1,
    },
    opacity: {
      value: {
        min: 0.05,
        max: 0.5,
      },
      animation: {
        enable: true,
        speed: 1,
        sync: false,
      },
    },
  },
  interactivity: {
    events: {
      onClick: {
        enable: true,
        mode: "push",
      },
    },
    modes: {
      push: {
        quantity: 1,
      },
    },
  },
  detectRetina: true,
};

function Particle() {
  return (
    <ParticlesProvider init={initializeParticles}>
      <Particles
        id="tsparticles"
        options={particleOptions}
      />
    </ParticlesProvider>
  );
}

export default Particle;
